export default class MenuOpcao {
    title: string;
    path: string;
    render: boolean;
    subItems: MenuOpcao[];
    acao: string;
    icon: string | null;
    iconLicense: string | null;
    constructor(
        title: string,
        path: string,
        render: boolean,
        subItems: MenuOpcao[] = [],
        acao: string,
        icon: string | null,
        iconLicense: string | null
    ) {
        this.title = title;
        this.path = path;
        this.render = render;
        this.subItems = subItems;
        this.acao = acao;
        this.icon = icon;
        this.iconLicense = iconLicense;
    }
}
